import { BASE_URL } from "../config/settings";
import storeInit from "../redux/store";
import axios from "axios";


export const downloadUsers = async () => {
  const token = storeInit.store.getState()?.auth?.user?.token?.token;

  return await axios.get(`${BASE_URL}/export/users`, {
    responseType: "blob",
    headers: {
      Authorization: `Bearer ${token}`,
      language: "en",
    },
  });
};
export const downloadLOB = async () => {
  const token = storeInit.store.getState()?.auth?.user?.token?.token; 
  return await axios.get(`${BASE_URL}/export/download-line-of-business`, {
    responseType: "blob",
    headers: {
      Authorization: `Bearer ${token}`, 
      language: "en",
    },
  });
}

export const downloadClients = async () => {
  const token = storeInit.store.getState()?.auth?.user?.token?.token; 
  return await axios.get(`${BASE_URL}/export/download-clients`, {
    responseType: "blob",
    headers: {
      Authorization: `Bearer ${token}`, 
      language: "en",
    },
  });
}

export const downloadProjects = async () => {
  const token = storeInit.store.getState()?.auth?.user?.token?.token; 
  return await axios.get(`${BASE_URL}/export/download-projects`, {
    responseType: "blob",
    headers: {
      Authorization: `Bearer ${token}`, 
      language: "en",
    },
  });
}
export const downloadChangeRequests = async () => {
  const token = storeInit.store.getState()?.auth?.user?.token?.token; 
  return await axios.get(`${BASE_URL}/export/download-change-request-projects`, {
    responseType: "blob",
    headers: {
      Authorization: `Bearer ${token}`, 
      language: "en",
    },
  });
}

export const downloadSupportRequests = async () => {
  const token = storeInit.store.getState()?.auth?.user?.token?.token; 
  return await axios.get(`${BASE_URL}/export/download-support-projects`, {
    responseType: "blob",
    headers: {
      Authorization: `Bearer ${token}`, 
      language: "en",
    },
  });
}



